import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDropUp = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 8 5",
	height: 5,
	width: 8,
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		xmlns: "http://www.w3.org/2000/svg",
		transform: "matrix(-1 0 0 -1 8 5)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.3767 4.0211L1.14213 1.78653C0.857513 1.50191 0.793088 1.17467 0.948855 0.8048C1.10462 0.434934 1.38506 0.25 1.79018 0.25H6.2286C6.63372 0.25 6.91416 0.434934 7.06993 0.8048C7.2257 1.17467 7.16128 1.50191 6.87668 1.78653L4.64208 4.0211C4.5485 4.1147 4.44978 4.18329 4.34593 4.22688C4.24208 4.27046 4.1299 4.29225 4.0094 4.29225C3.88889 4.29225 3.7767 4.27046 3.67285 4.22688C3.56902 4.18329 3.4703 4.1147 3.3767 4.0211Z",
			fill: "#1C1B1F"
		})
	})
});
export default SvgArrowDropUp;
